<!-- Le message, sa raison, son geste : la seule masse forte de l'accueil. -->
<section class="relative rounded-sheet bg-gradient-to-b px-4 pb-3 pt-3 ring-1 ring-inset ring-vw-line" data-test="day-message"
  [ngClass]="tone.card" (pointerdown)="actions && pressStart()" (pointerup)="pressEnd()" (pointercancel)="pressEnd()"
  (pointerleave)="pressEnd()" (contextmenu)="onContextMenu($event)">
  @if (message.signal) {
    <p class="flex flex-wrap items-center gap-x-1.5 text-body-s font-semibold" [ngClass]="tone.ink" data-test="day-signal">
      <span class="block h-[18px] w-[18px] shrink-0 [&_svg]:h-full [&_svg]:w-full" aria-hidden="true">
        <ng-container *ngComponentOutlet="icons[message.signal.icon]"></ng-container>
      </span>
      <span>{{ message.signal | vwDayText }}</span>
      @if (message.source) {
        <span class="font-normal text-vw-muted">{{ message.source | vwDayText }}</span>
      }
    </p>
  }
  <h2 class="mt-1 font-display font-semibold leading-tight text-vw-ink" [vwFitLines]="3" [steps]="[26, 24, 22]"
    (overflowChange)="onOverflow($event)" data-test="day-title">
    @if (useShort) {
      {{ message.shortTitle | vwDayText }}
    } @else {
      {{ message.title | vwDayText }}
    }
  </h2>
  @if (message.reason.length) {
    <div class="mt-2 flex items-center gap-3">
      @if (pictures.length === 1) {
        <img [src]="pictures[0].imageUrl" alt="" class="vw-plant-thumb" />
      } @else if (pictures.length > 1) {
        <span class="flex shrink-0" aria-hidden="true">
          @for (plant of pictures; track $index) {
            <img [src]="plant.imageUrl" alt="" class="h-10 w-10 rounded-pill bg-vw-surface-tint object-cover ring-2 ring-vw-surface"
              [class.-ml-3]="$index > 0" />
          }
        </span>
      }
      <p class="min-w-0 grow text-body-s text-vw-body" data-test="day-reason">
        @for (part of message.reason; track $index) {
          @let said = part | vwDayText;
          @if (part.estimated) {
            <!-- La pastille juste après ce qui est estimé, avant le point : « levées (estimé). » -->
            {{ withoutPeriod(said) }} <vw-tag tone="estimate" [label]="'home.day.estimated' | translate"></vw-tag>{{ said.endsWith('.') ? '.' : '' }}
          } @else {
            {{ said }}
          }
        }
        @if (message.estimated && !estimatedInReason) {
          <vw-tag tone="estimate" [label]="'home.day.estimated' | translate"></vw-tag>
        }
      </p>
    </div>
  }
  @if (message.note) {
    <p class="mt-2 text-body-s text-vw-muted" data-test="day-note">{{ message.note | vwDayText }}</p>
  }
  @if (actions) {
  <div class="mt-3 flex items-center gap-2">
    @if (message.button) {
      <!-- Une action, jamais un état : le cercle vide se remplit quand la personne répond. -->
      <vw-button look="secondary" [tone]="buttonTone" [label]="'home.day.button.' + buttonLabel" [iconTemplate]="circle"
        (onClick)="act.emit(message)" data-test="day-act"></vw-button>
      <ng-template #circle><vw-circle-icon class="h-5 w-5" aria-hidden="true"></vw-circle-icon></ng-template>
    }
    <button type="button" data-test="day-more" (click)="more.emit(message)" [attr.aria-label]="'home.day.more' | translate"
      class="flex h-target w-target shrink-0 items-center justify-center rounded-pill bg-vw-surface text-vw-body ring-1 ring-inset ring-vw-line active:bg-vw-surface-sunk">
      <vw-three-dots-icon class="block rotate-90" aria-hidden="true"></vw-three-dots-icon>
    </button>
  </div>
  }
</section>
